export default "__VITE_ASSET__C7y7rDEw__"